import { baseSource } from "./base-source.js";
export const boundaryTableSource = async function (options) {
    const { filters, tilesetTableName, columns, propertiesTableName } = options;
    const urlParameters = {
        tilesetTableName,
        propertiesTableName
    };
    if (columns) {
        urlParameters.columns = columns.join(',');
    }
    if (filters) {
        urlParameters.filters = filters;
    }
    return baseSource('boundary', options, urlParameters);
};
